/**
 *
 * Section Step2 - Recipient
 *
 */

/*
 * Data collected:
 *
 * recipientTitle
 * recipientFirstName
 * recipientLastName
 * recipientAddress1
 * recipientAddress2
 * recipientCity
 * recipientCountry (can be taken from language selection)
 *
 */

import PropTypes from "prop-types";
import BackSvg from "../partials/BackSvg.jsx";
import RecipientSearch from "../components/RecipientSearch.jsx";

// Based on https://www.freecodecamp.org/news/how-to-validate-forms-in-react/
import { Input } from "../components/Input.jsx";
import { FormProvider, useForm } from "react-hook-form";
import { required_validation } from "../utils/inputValidations";
import { useEffect, useState } from "react";

function Step2(props) {
  const [searchField, setSearchField] = useState("");
  const methods = useForm();
  const onSubmit = methods.handleSubmit((data) => {
    props.emitChangeSection("step3");
  });

  /*
   *  Handle change text input
   */
  const handleChange = (e) => {
    props.emitUpdateFormdata(e.target.name, e.target.value);
  };

  /*
   *  Handle search Field change
   */
  const handleSearchChange = (e) => {
    setSearchField(e.target.value);
  };

  /*
   *  Handle change of a check box
   */
  const handleCheckBoxClick = (e) => {
    props.emitUpdateFormdata(e.target.name, !props.formData.customRecipient);
  };

  return (
    <div className="step" id="step2">
      {/* Headline & Intro */}
      <div className="row">
        <div className="col col-10">
          <h1 className="headline">Select your GP</h1>
          <div className="progress bar1">&nbsp;</div>
        </div>
      </div>
      <div className="row">
        <div className="col col-8">
          <p className="intro">Who is your general practitioner? *</p>
        </div>
      </div>

      <FormProvider {...methods}>
        <form
          onSubmit={(e) => e.preventDefault()}
          noValidate
          className="container"
        >
          <div className="row">
            <div className="col col-8">
              <input
                name="searchField"
                placeholder="Search"
                value={searchField}
                onChange={handleSearchChange}
              />

              <RecipientSearch
                formData={props.formData}
                searchField={searchField}
                locale={props.formData.locale}
                emitHandleChange={handleChange}
              />
            </div>
          </div>

          <div className="row">
            <div className="col col-8">
              <Input
                label="name of organization"
                type="text"
                name="recipientOrganization"
                maxlength="40"
                value={props.formData.recipientOrganization}
                handleChange={(e) => handleChange(e)}
                placeholder="name of organization"
                validation={{
                  required: {
                    value: props.formData.customRecipient ? true : false,
                    message: "required",
                  },
                }}
              />

              <Input
                label="Title"
                type="text"
                name="recipientTitle"
                maxlength="10"
                value={props.formData.recipientTitle}
                handleChange={(e) => handleChange(e)}
                placeholder="title"
              />

              <Input
                label="What is the name of your GP?"
                type="text"
                name="recipientFirstName"
                maxlength="20"
                value={props.formData.recipientFirstName}
                handleChange={(e) => handleChange(e)}
                placeholder="last name of your GP"
              />

              <Input
                label="Last name "
                type="text"
                maxlength="20"
                name="recipientLastName"
                value={props.formData.recipientLastName}
                handleChange={(e) => handleChange(e)}
                placeholder="last name"
              />

              <div className="fadeIn" disabled={props.formData.customRecipient}>
                <Input
                  label="Address"
                  type="text"
                  name="recipientAddress1"
                  maxlength="20"
                  value={props.formData.recipientAddress1}
                  handleChange={(e) => handleChange(e)}
                  placeholder="line 1"
                  validation={{
                    required: {
                      value: props.formData.customRecipient ? true : false,
                      message: "required",
                    },
                  }}
                />
                <Input
                  type="text"
                  name="recipientAddress2"
                  maxlength="20"
                  value={props.formData.recipientAddress2}
                  handleChange={(e) => handleChange(e)}
                  placeholder="line 2"
                  validation={{
                    required: {
                      value: props.formData.customRecipient ? true : false,
                      message: "required",
                    },
                  }}
                />
                <Input
                  label="City"
                  type="text"
                  name="recipientCity"
                  maxlength="20"
                  value={props.formData.recipientCity}
                  handleChange={(e) => handleChange(e)}
                  placeholder="city"
                  validation={{
                    required: {
                      value: props.formData.customRecipient ? true : false,
                      message: "required",
                    },
                  }}
                />

                <Input
                  label="Country"
                  type="text"
                  name="recipientCountry"
                  maxlength="20"
                  value={props.formData.recipientCountry}
                  handleChange={(e) => handleChange(e)}
                  placeholder="country"
                  validation={{
                    required: {
                      value: props.formData.customRecipient ? true : false,
                      message: "required",
                    },
                  }}
                />
              </div>
            </div>
            {/*col*/}
          </div>
          {/*formRow*/}
        </form>
      </FormProvider>

      <div className="row">
        <div className="col flex-center">
          <div
            className="button buttonBack"
            onClick={(e) => props.emitChangeSection("step1", e)}
          >
            <BackSvg /> back
          </div>

          <div className="button buttonOptMeOut" onClick={onSubmit}>
            OptMeOut
          </div>
        </div>
        {/*col*/}
      </div>
      {/*row*/}
    </div>
  );
}

Step2.propTypes = {
  formData: PropTypes.object,
  emitChangeSection: PropTypes.func,
  emitUpdateFormdata: PropTypes.func,
};
export default Step2;
